
import { AlertTriangle, CheckCircle, AlertCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ValidationMessageProps {
  type: 'error' | 'success' | 'warning' | 'popup';
  message: string;
  className?: string;
}

export const ValidationMessage = ({ type, message, className }: ValidationMessageProps) => {
  if (!message) return null;

  const getIcon = () => {
    switch (type) {
      case 'error':
      case 'popup':
        return <AlertTriangle className="h-4 w-4" />;
      case 'success':
        return <CheckCircle className="h-4 w-4" />;
      case 'warning':
        return <AlertCircle className="h-4 w-4" />;
      default:
        return <AlertTriangle className="h-4 w-4" />;
    }
  };

  const getStyles = () => {
    switch (type) {
      case 'error':
        return "text-destructive";
      case 'success':
        return "text-green-600";
      case 'warning':
        return "text-orange-500 bg-orange-50 dark:bg-orange-950/20 px-3 py-2 rounded-md border-l-4 border-orange-500";
      case 'popup':
        return "text-orange-600 bg-orange-50 dark:bg-orange-950/20 px-3 py-2 rounded-md border border-orange-200 dark:border-orange-800 shadow-sm";
      default:
        return "text-destructive";
    }
  };

  return (
    <div 
      className={cn(
        "flex items-center gap-2 text-sm mt-1",
        getStyles(),
        className
      )}
    >
      {getIcon()}
      <span>{message}</span>
    </div>
  );
};
